module.exports = __webpack_public_path__ + "img/icon-banner.3d56bccb.png";